import { HttpResult, none, Unit } from 'widgets-for-react'
import { IdealIssuer, PaymentMethod, TransactionStatus } from '../types/types'
import { getCsrfToken } from '../utils/csrf'
import { prefixUrlWithLocale } from '../utils/url'

export type IdealIssuerResponse = { ideal_issuers: IdealIssuer[] }

export type StartPaymentResponse = {
  success: boolean
  redirectUrl?: string
}

export type StartPaymentInput = {
  payment_id: string
  payment_method: string
  ideal_issuer: string
}

export type PaymentStatus = {
  marked_as_paid: boolean
  status: TransactionStatus
  is_paid_status: boolean
  is_ongoing_status: boolean
}
export type PaymentStatusResponse = {
  status: PaymentStatus
  booking_url: string
}

export async function getPaymentMethods(
  bookingId: string
): Promise<HttpResult<PaymentMethod[]>> {
  const res = await fetch(
    prefixUrlWithLocale(`/api/opp/bookings/${bookingId}/payment_methods`),
    { cache: 'no-store' }
  )
  const methods = await res.json()
  return { kind: 'result', value: methods, status: 200 }
}

export async function getIdealIssuers(): Promise<
  HttpResult<IdealIssuerResponse>
> {
  const res = await fetch(prefixUrlWithLocale('/api/opp/ideal_issuers'), {
    cache: 'no-store'
  })
  const methods = await res.json()
  return { kind: 'result', value: methods, status: 200 }
}

export async function startPayment(
  input: StartPaymentInput
): Promise<HttpResult<StartPaymentResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/opp/payments/${input.payment_id}/create_transaction`
    ),
    {
      method: 'post',
      body: JSON.stringify(input),
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-CSRF-Token', getCsrfToken()]
      ]
    }
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }

  const methods = await res.json()
  return { kind: 'result', value: methods, status: 200 }
}

export async function getPaymentStatus(
  paymentId: string
): Promise<HttpResult<PaymentStatusResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(`/api/opp/payments/${paymentId}/status`),
    {
      method: 'get',
      cache: 'no-store',
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json']
      ]
    }
  )
  const notification = (await res.json()) as PaymentStatusResponse
  return { kind: 'result', value: notification, status: 200 }
}

export async function setFlashAndFirstTerm(
  paymentId: string,
  type: 'alert' | 'notice',
  message: string
): Promise<HttpResult<Unit>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/opp/payments/${paymentId}/before_status_redirect`
    ),
    {
      method: 'post',
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-CSRF-Token', getCsrfToken()]
      ],
      body: JSON.stringify({
        type,
        message
      })
    }
  )

  return { kind: 'result', value: none(), status: res.status }
}
